import uuid from "uuid";
import EventManager from "../../../store/sqftEventManager";
import WaterfallSegment from "../shapeParts/models/waterfallSegment";
import {WATERFALL_OVERLAY_TYPE, WATERFALL_SHAPES_KEY, WATERFALL_SHAPES_NAME} from "../../../../../constants";
import config from "../../../store/sqftConfig";
import {isWesternHemisphere} from "../../../helpers/lineHelper";

export default class WaterfallOverlay {
  id;
  sectionIndex;
  line;
  type; // WATERFALL_OVERLAY_TYPE
  state = {
  };
  design = {
  };
  segments = []; // array of WaterfallSegments

  constructor(line, sectionIndex, importData, type = WATERFALL_OVERLAY_TYPE.waterfall) {
    this.line = line;
    this.sectionIndex = sectionIndex;
    this.id = uuid();
    this.type = type;
    if (importData) {
      this.importData(importData)
    } else {
      switch (type) {
        case WATERFALL_OVERLAY_TYPE.peninsulaUnderwrap:
          this.createPeninsulaUnderwrapSections();
          break;
        case WATERFALL_OVERLAY_TYPE.waterfall:
        default:
          this.createWaterfallSections();
          break;
      }
    }
  }

  getSegments = () => { return this.segments; }
  getEnabledSegments = () => { return this.segments.filter(segment => !segment.isDisabled) }
  getParent = () => { return this.line; }
  setSegments = (value) => { this.segments = value; }
  addSegment = (segment) => { this.segments.push(segment); }

  destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.segments.forEach((segment) => {
        segment.destroy();
      });
    }
  };

  initEvents = () => {
  };

  deregisterEvents = () => {
    EventManager.removeEvent(this);
  };

  reInitEvents = () => {
    this.initEvents();
  };

  export = () => {
    return this.exportData();
  }

  exportData = () => {
    return {
      id: this.id,
      lineId: this.line.id,
      state: this.state,
      type: this.type,
      segments: this.segments.map((segment) => {
        return segment.exportData()
      }),
    }
  };

  importData = (importData) => {
    this.state = importData.state;
    for (const segmentData of importData.segments) {
      this.addSegment(new WaterfallSegment(
        segmentData.key,
        segmentData.name,
        segmentData.length,
        segmentData.height,
        segmentData.thickness,
        this,
        segmentData.isDisabled
      ));
    }
  };

  createWaterfallSections = () => {
    const nextLine = this.line.getParent().getNextLine(this.line);
    const thickness = config.measureUnit === "Imperial" ? 1.5 : 40;
    const height = config.measureUnit === "Imperial" ? 36 : 900;
    const waterfallLength = config.measureUnit === "Imperial" ? this.line.getLineLength() : this.line.getLineLengthMm();
    const underlaymentLength = config.measureUnit === "Imperial" ? nextLine.getLineLength() : nextLine.getLineLengthMm();

    //place mirror shape in the slab mode
    const lineDirection = this.line.getLineDirectionV2();
    const isLineInWesternHemisphere = isWesternHemisphere(lineDirection) ;
    const defaultCabinetReturnLength = config.measureUnit === "Imperial" ? 4 : 60;
    const defaultOverhangReturnLength = config.measureUnit === "Imperial" ? 20 : 300;
    const cabinetReturnLength = isLineInWesternHemisphere ? defaultCabinetReturnLength : defaultOverhangReturnLength;
    const overhangReturnLength = isLineInWesternHemisphere ? defaultOverhangReturnLength : defaultCabinetReturnLength;

    const segments = [
      new WaterfallSegment(WATERFALL_SHAPES_KEY.waterfall, WATERFALL_SHAPES_NAME.waterfall, waterfallLength, height, thickness, this),
      new WaterfallSegment(WATERFALL_SHAPES_KEY.cabinetReturn, WATERFALL_SHAPES_NAME.cabinetReturn, cabinetReturnLength, height, thickness, this, true),
      new WaterfallSegment(WATERFALL_SHAPES_KEY.overhangReturn, WATERFALL_SHAPES_NAME.overhangReturn,overhangReturnLength, height, thickness,  this, true),
      new WaterfallSegment(WATERFALL_SHAPES_KEY.underlayment, WATERFALL_SHAPES_NAME.underlayment, underlaymentLength, height, thickness,  this, true),
    ];
    this.setSegments(segments);
  }

  createPeninsulaUnderwrapSections = () => {
    const segments = [
      new WaterfallSegment(WATERFALL_SHAPES_KEY.peninsulaUnderwrap, WATERFALL_SHAPES_NAME.peninsulaUnderwrap, this.line.getLineLength(), 36, 1.5, this, false),
    ];
    this.setSegments(segments);
  }

  getArea = () => {
    return this.segments.reduce((sum, segment) => sum + segment.getArea(), 0)
  }
}
